import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';
import EventBus from 'diagram-js/lib/core/EventBus';
import { ModelingUtil } from '@ispm/shared/bpmn-io/modeling-util';
import { NodeType } from '@ispm/shared/bpmn-io/node-type';
import { EventType } from '@ispm/shared/bpmn-io/bpmn-js';
import { OverlayType } from '@ispm/shared/bpmn-io/overlay-types';
import {replace, get} from 'lodash';
import { Shape } from 'diagram-js/lib/model';
import {constants} from "@ispm-client/modules/bpmn-modeler/constants/constants";


/**
 * Created By Soibam Homer on 03/05/23
 */

export class TreatmentPlanOverlayBehaviour extends CommandInterceptor {

  constructor(protected eventBus: EventBus, private overlays, private config: any) {
    super(eventBus);
    eventBus.on([EventType.SHAPE_ADDED,EventType.NODE_ADDED ], (event) => {
      const element = event.node ?? event.context?.node ;
      const enableNodeId = get(this.config, 'behavior.enablePathwaysTreatmentPlanNodeId', true);

      if (enableNodeId && element && ModelingUtil.getNodeType(element) === NodeType.treatment) {
        if(element.id.startsWith("Node_")) {
          this.addNodeIdOverlay(element);
        }
      }
    });
  }

  addNodeIdOverlay(node: Shape) {
    const nodeId = replace(node.id,"Node_", "" );
    const nodeIdLength = nodeId.length * 7;
    this.overlays.add(node.id, OverlayType.treatmentPlanOverlayBehaviour, {
      position: {
        top: constants.NODE_ID_POSITION.top,
        right:constants.NODE_ID_POSITION.right + nodeIdLength
      },
      html: `<div class="treatmentPlan-overlay-container">${nodeId}</div>`
    });
  }
}


TreatmentPlanOverlayBehaviour.$inject = ['eventBus', 'overlays','config'];

